/** Latin-digit number formatting for dashboards. */
export function formatNumber(value: number, fractionDigits = 0): string {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  }).format(value);
}

/** Currency value with the admin-configured symbol. */
export function formatCurrency(value: number, symbol = 'ر.س'): string {
  return `${formatNumber(value, 2)} ${symbol}`;
}

const AR_DATE = new Intl.DateTimeFormat('ar-SA-u-nu-latn', {
  weekday: 'long',
  day: '2-digit',
  month: 'long',
  year: 'numeric',
});

const AR_DATETIME = new Intl.DateTimeFormat('ar-SA-u-nu-latn', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

const EN_DATE = new Intl.DateTimeFormat('en-GB', {
  weekday: 'long',
  day: '2-digit',
  month: 'long',
  year: 'numeric',
});

const EN_DATETIME = new Intl.DateTimeFormat('en-GB', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});

export function formatDate(value: string | Date, lang: string = 'ar'): string {
  const date = typeof value === 'string' ? new Date(value) : value;
  return (lang.startsWith('ar') ? AR_DATE : EN_DATE).format(date);
}

export function formatDateTime(value: string | Date, lang: string = 'ar'): string {
  const date = typeof value === 'string' ? new Date(value) : value;
  return (lang.startsWith('ar') ? AR_DATETIME : EN_DATETIME).format(date);
}

export function isSameDay(a: Date, b: Date): boolean {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

export function isToday(value: string | Date): boolean {
  const date = typeof value === 'string' ? new Date(value) : value;
  return isSameDay(date, new Date());
}

export function formatTime(value: string, lang: string = 'ar'): string {
  if (!value) return '';
  const [h, m] = value.split(':');
  const hour = Number(h);
  const isArabic = lang.startsWith('ar');
  const suffix = isArabic ? (hour < 12 ? 'ص' : 'م') : hour < 12 ? 'AM' : 'PM';
  const normalized = hour % 12 === 0 ? 12 : hour % 12;
  return `${String(normalized).padStart(2, '0')}:${m} ${suffix}`;
}